import { useState, useEffect, lazy, Suspense } from "react";

import axios from 'axios';

import { getNeedsSelection, getTableParam, setTableParam } from '@/utils/Table';

const Button = lazy(() => import('@/components/Button'));

import { checkRender } from "@/utils/Render";

//const PowerBIEmbed = lazy(() => import('powerbi-client-react'));
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
//import Backdrop from '@mui/material/Backdrop';
//import CircularProgress from '@mui/material/CircularProgress';

const Backdrop = lazy(() => import('@mui/material/Backdrop'));
const CircularProgress = lazy(() => import('@mui/material/CircularProgress'));

import { getCurrentTab, getNewUrl } from '@/utils/Tabs';
import { styleTabs, styleBackdrop } from '@/utils/Styles';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
    BarChart as ChartsIcon,
    Article as DocumentsIcon,
    //PictureAsPdf as PDFIcon,
    AttachFile as DocumentIcon,
    //Download as DownloadIcon,
    Email as EmailIcon,
    Fullscreen as FullscreenIcon
} from '@mui/icons-material';

import { size } from '@/utils/Format';
import { date } from '@/utils/Dates';

import { setParam } from '@/utils/Cookies';

import { getParameterURL }  from '@/utils/URL';

const ReportNotificationModal = lazy(() => import('@/modals/ReportNotificationModal'));

/*
import { 
    GetApp as ExportIcon,
    PictureAsPdf as PDFIcon,
    Slideshow as PowerPointIcon,
    TableRows as ExcelIcon,
} from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
*/

export default function Reports({ t, user, apiUrl, token, router, report, getDataReport,
    language, sendMessage, handleLogin, openUrlModal, fullScreen, fullPage, setFullPage }) {

    const [open] = useState(true);
    const [showLoading, setShowLoading] = useState(false);

    // response from the api when getting data
    //const [ response, setResponse ] = useState(null);

    // to save the info to be shown
    const [reportData, setReportData] = useState(null);
    const [documentsData, setDocumentsData] = useState(null);

    const [needsSelection, setNeedsSelection] = useState(null);
    const [selectionItem, setSelectionItem] = useState(null);

    const { sxTabs, sx, sxIcon } = styleTabs();
    const { sxBackdrop } = styleBackdrop();
    //const regExp = /\/([a-zA-Z]+)\/documents$/;

    // tabs in order
    // by default it takes the first one
    const tabs = ['charts', 'documents'];
    const [tab, setTab] = useState(getCurrentTab(router, tabs));

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
        const url = getNewUrl(router, report, tabs, newValue);
        router.navigate(url);
        //window.history.pushState({path:url},'',url);
    };

    const [filesUrls, setFilesUrls] = useState([]);

    const [render, setRender] = useState(null);

    // what to do when clicking on the button to change parent element
    // where the report depends on
    const handleTableItemSelected = () => {

        var parent = getNeedsSelection(router.pathname, report);

        /*
        var split = path.split('/');
        var parent = split[1];            
        */
        router.navigate('/' + parent);
    };

    // if clicking on the menu, go back to main tab
    useEffect(() => {
        if (router.pathname) {
            setTab(getCurrentTab(router, tabs));
        }

    }, [router.pathname]);

    // get data
    useEffect(() => {

        // if charts and data not retrieved yet
        // or documents and data not retrieved yet
        if (
            (tab === 'charts' && reportData === null) ||
            (tab === 'documents' && documentsData === null)
        ) {

            // if on menu/submenu where the parent menu needs a selection   
            var retrieveData = true;

            var needsSelectionCheck = getNeedsSelection(router.pathname, report);

            let selected = null;
            if (needsSelectionCheck) {

                setNeedsSelection(needsSelectionCheck);

                // check if selected by url parameter                
                selected = getParameterURL(router,'selected');
                let itemInfo = null;
                if(selected){
                    const selectedName = getParameterURL(router,'selectedName');
                    itemInfo = {
                        id: parseInt(selected), 
                        name: selectedName
                    };
                    
                    setTableParam(user,needsSelectionCheck,'selected',itemInfo);
                }
                else{

                    // if not by parameter
                    // check if item selected
                    itemInfo = getTableParam(user, needsSelectionCheck, 'selected');
                }

                setSelectionItem(itemInfo);

                // show if item selected or not
                var renderTable = checkRender(t, null, user, router.pathname, report, null, null, null, handleTableItemSelected, sendMessage);
                setRender(renderTable);

                // if submenu and item not selected, do not retrieve data
                if(needsSelection !== report && !itemInfo?.id){
                    retrieveData = false;
                }
            }
            else {
                setNeedsSelection(null);
                setSelectionItem(null);
            }

            if (retrieveData) {
                getDataReport(router.pathname, report, tab, null, setReportData, setDocumentsData);
            }
        }

    }, [tab]);

    /*
    const [ reportObject, setReportObject ] = useState(null);
    const handleExportPDF = () => {

        // if private report
        if(reportData?.accessToken){
            
            if(reportObject){
                // print with powerbi api
                reportObject.print();
            }
        }
        else{
            // public report
            // does not work
            
            //const iframe = document.querySelector('.powerbi-frame iframe');
            //console.log(iframe)
            //if(iframe){                    
            //    iframe.contentWindow.print();
            //}
        }
    };
    */

    const getFile = (mime, name, url, action = 'download') => {

        // download
        if (action !== 'view') {
            // create link
            const link = document.createElement("a");
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // free temporary url
            //window.URL.revokeObjectURL(url);
        }
        else {
            const title = name;
            const disclaimer = t('legal.policy.download');
            openUrlModal(url, true, null, mime, name, title, disclaimer, false, false, false);
        }
    }

    const openDocument = async (file, action = 'download') => {

        const name = file?.name;
        const mime = file?.file?.mimeType;

        // if action is view but not pdf, download
        if (action === 'view' && mime !== 'application/pdf' && mime !== 'application/x-pdf') {
            // for the moment not possible to view
            // because we don't want the user to download it
            //action = 'download';
            sendMessage(t('actions.view.disabled'), 'error');
            return;
        }

        // check if already got the file
        if (filesUrls && Object.hasOwn(filesUrls, file?.id)) {
            getFile(mime, name, filesUrls[file?.id], action);
        }
        else {

            setShowLoading(true);

            const errorMessage = t('actions.download.error');

            const apiPath = '/' + report + '/list';

            const config = {
                headers: { Authorization: `Bearer ${token}` },
                params: {
                    selectedId: selectionItem?.id,
                    language: language,
                    companyuser: user?.company,
                    type: 'download',
                    siteId: file?.parentReference?.siteId,
                    driveId: file?.parentReference?.driveId,
                    itemId: file?.id,
                    name: name,
                    mime: mime
                },
                responseType: 'blob'
            };

            const url = apiUrl + apiPath;

            await axios.get(url, config)
                .then(function (response) {

                    if (response?.data) {

                        const responseData = response.data;
                        const responseHeaders = response?.headers['content-type'];

                        // if result is ok                
                        if (responseHeaders === mime) {

                            //const fileURL = window.URL.createObjectURL(new Blob([responseData]));
                            const fileURL = window.URL.createObjectURL(new Blob([responseData], { type: mime }));

                            // save just in case we open again
                            const newFilesUrls = filesUrls;
                            newFilesUrls[file?.id] = fileURL;
                            setFilesUrls(newFilesUrls);

                            getFile(mime, name, fileURL, action);
                        }
                        else {

                            if (responseData?.status && responseData.status === 401) {
                                handleLogin();
                            }
                            else {
                                sendMessage(errorMessage, 'error');
                            }
                        }
                    }
                    else {
                        sendMessage(errorMessage, 'error');
                    }

                    setShowLoading(false);
                })
                .catch(function (error) {

                    if (error?.status && error.status === 401) {
                        handleLogin();
                    }
                    else {
                        sendMessage(errorMessage, 'error');
                    }

                    setShowLoading(false);
                });
        }
    }

    const handleButtonFullscreen = () => {		
        setFullPage(fullPage ? false : true);

        // save on cookies
        setParam('fullPage',fullPage ? 0 : 1);
    }

    // to open send notification modal
    const [ showNotificationModal, setShowNotificationModal ] = useState(false);
    const handleSendNotification = () => {
        setShowNotificationModal(true);
    }

    /*
    const generatePDF = async () => {
    const pages = await reportObj.getPages();
    const pdf = new jsPDF();

    for (let i = 0; i < pages.length; i++) {
        await pages[i].setActive();
        // Esperar a que se renderice la página
        await new Promise(r => setTimeout(r, 1000));

        const canvas = await html2canvas(document.querySelector('.powerbi-frame'));
        const imgData = canvas.toDataURL('image/png');

        if (i > 0) pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // A4
        }

        pdf.save("reporte.pdf");
    };

    */

    /*
    async function exportToPDF(report) {
        try {
            const exportConfig = {
                format: "PDF"
                // { pages: ["ReportSection1", "ReportSection2"] }
            };

            // launch export
            const result = await report.exportToFile(exportConfig);
            //console.log("Export job started:", result.id);

            // this returns the jobId. go to backend to generate the pdf
        }
        catch (err) {
            //console.error(err);
        }
    }
    */

    // to export
    /*
    const [ anchorEl, setAnchorEl ] = useState(null);
    const handleButtonExport = async (docType) => {

        var errorMessage = t('actions.export.error');

        if(reportData?.reportId){
        
            const apiPath = '/'+report+'/list';     

            const config = {
                headers: { Authorization: `Bearer ${token}` },                   
                params: {
                    selectedId: ,
                    language: language,
                    companyuser: user?.company,
                    type: 'export',
                    doc: docType,
                    reportId: reportData?.reportId,
                    reportUrl: reportData?.reportUrl
                }  
            }; 


            const url = apiUrl+apiPath;
            
            await axios.get(url,config)
            .then(function (response) {
                    
                //if(response?.data){
              console.log(response)
                    //var responseData = response.data;

                    // if result is ok
                    //if(responseData?.result){              
                    if(response?.ok){
                        
                        var fileName = t(report+'.file');
                        switch(docType){                            

                            case 'excel':
                                fileName = fileName+'.pdf';
                                break;

                            case 'ppt':
                                fileName = fileName+'.pdf';
                                break;

                            case 'pdf':
                            default:
                                break;
                        }
                        
                        //sendMessage(t('actions.send.success'),'success');
                        // we receive the file as blob
                        const blob = response.blob();
                        const url = window.URL.createObjectURL(blob);

                        // create link
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        // free temporary url
                        window.URL.revokeObjectURL(url);
                        
                    } 
                    else{

                        if(responseData?.status && responseData.status === 401){
                            //handleLogin();
                        }
                        else{                                              
                            sendMessage(errorMessage,'error');
                        }
                    }
                //}
                //else{
                //    sendMessage(errorMessage,'error');   
                //}
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    //handleLogin();
                }
                else{                   
                    sendMessage(errorMessage,'error');
                }
            });
        }
        else{
            sendMessage(errorMessage,'error');
        }
    }
    */

    return (
        <>
        <ReportNotificationModal
            t={t}
            report={report}
            open={showNotificationModal}
            setOpen={setShowNotificationModal}
            fullScreen={fullScreen}
            apiUrl={apiUrl}
            token={token}
            language={language}
            sendMessage={sendMessage}
            handleLogin={handleLogin}
            user={user}
            users={
                tab === 'documents' ? 
                    documentsData?.users
                : 
                    reportData?.users
            }
            item={selectionItem}
        />
        <div className='tabs-container size-full'>
            {
                (!needsSelection || needsSelection === report || selectionItem?.id) &&
                (
                    (tab === 'documents' && documentsData === null) ||
                    (tab === 'charts' && reportData === null) ||
                    showLoading
                ) &&
                <Suspense>
                    <Backdrop
                        //sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 */})}
                        open={open}
                        sx={sxBackdrop}
                    //onClick={handleClose}
                    >
                        <CircularProgress color="inherit" sx={{ marginLeft: '210px' }} />
                    </Backdrop>
                </Suspense>
            }
            {
                needsSelection && needsSelection !== report && !selectionItem?.id ?
                    <div className=''>
                        <div className='text-center my-4'>
                            {t('actions.notselected.text', { table: t(needsSelection + '.menu.title') })}
                        </div>
                        <Suspense>
                            <Button
                                onClick={() => router.navigate('/' + needsSelection)}
                                text={t('actions.notselected.button')}
                                type="select"
                                variant="contained"
                                sx={{ width: '100%' }}
                            />
                        </Suspense>
                    </div>
                    :
                    <>
                        {render}                        
                        <div className='flex justify-center items-center w-full max-md:grid max-md:grid-cols-12'>                            
                        {
                            ((tab === 'documents' && documentsData?.manage === 1) || (reportData !== null && reportData?.manage === 1)) &&
                            <div className={'mx-1 max-md:my-1 max-md:col-span-12 max-md:text-center'}>
                                <Suspense>
                                    <Button
                                        onClick={handleSendNotification}
                                        text={t(report+'.update.button')}
                                        type="appoutlined"
                                        startIcon={<EmailIcon />}
                                    />
                                </Suspense>
                            </div>
                        }
                            <div className={'mx-1 max-md:my-1 max-md:col-span-12 max-md:text-center'}>
                                <Button            
                                    onClick={handleButtonFullscreen}	                    
                                    type="appoutlined"
                                    startIcon={<FullscreenIcon/>}
                                    text={'tamaño'}
                                />
                            </div>
                        </div>
                        <Tabs
                            id="tabs"
                            sx={sxTabs}
                            value={tab}
                            onChange={handleTabChange}
                            variant="scrollable"
                        >
                            <Tab icon={<ChartsIcon sx={sxIcon} />} value="charts" label={t(report + '.tabs.charts')} sx={sx} />
                            <Tab icon={<DocumentsIcon sx={sxIcon} />} value="documents" label={t(report + '.tabs.documents')} sx={sx} />
                        </Tabs>
                        <div className='mt-8 size-full'>
                            {
                                tab === 'documents' ?
                                    <div>
                                        {
                                            documentsData !== null ?
                                                (documentsData === false || !documentsData?.documents || documentsData.documents.length === 0) ?
                                                    <div className='text-center mt-8 font-bold'>{t(report + '.errors.noaccessdocuments')}</div>
                                                    :
                                                    documentsData?.documents && documentsData.documents?.map((doc) => (
                                                        <div key={doc?.id} className='border rounded p-4 m-2 flex items-center'>
                                                            <div className="w-full">
                                                                <div className="cursor-pointer report-document" onClick={() => openDocument(doc, 'view')}>
                                                                    <DocumentIcon /> {doc?.name}
                                                                </div>
                                                                <div className="ml-8 text-xs">
                                                                    {date(doc?.lastModifiedDateTime, true, true)}<br /> {size(doc?.size, 'KB')}
                                                                </div>
                                                            </div>
                                                            {/*
                                                    <div className="cursor-pointer app-color" onClick={(e) => openDocument(doc,'download')}>
                                                        <DownloadIcon fontSize="large"/>
                                                    </div>
                                                    */}
                                                        </div>
                                                    ))
                                                :
                                                <></>
                                        }
                                    </div>
                                    :
                                    <div className='size-full'>
                                        <div className='size-full'>
                                            {
                                                reportData !== null ?

                                                    reportData === false ?
                                                        <div className='text-center mt-8 font-bold'>{t(report + '.errors.noaccesscharts')}</div>
                                                        :
                                                        <div className='size-full'>
                                                            {/*
                                                        reportData?.accessToken &&
                                                        <div className="text-center">
                                                            <Button                                     
                                                                onClick={handleExportPDF}
                                                                text={t('actions.export.button')}
                                                                color="primary"
                                                                //variant="contained"                         
                                                                startIcon={<PDFIcon/>}
                                                            />                                                                 
                                                            <Button                                     
                                                                onClick={(e) => setAnchorEl(e.currentTarget)}
                                                                text={t('actions.export.button')}
                                                                color="primary"
                                                                //variant="contained"                         
                                                                startIcon={<ExportIcon/>}
                                                            />  
                                                            <Menu
                                                                sx={{marginTop:0.2}}
                                                                anchorEl={anchorEl}
                                                                open={Boolean(anchorEl)}
                                                                onClose={(e) => setAnchorEl(null)}
                                                            >

                                                                <MenuItem 
                                                                    sx={{paddingRight:6.2}}
                                                                    onClick={(e) => handleButtonExport('pdf')}
                                                                >
                                                                    <ListItemIcon>
                                                                        <PDFIcon fontSize="small" />
                                                                    </ListItemIcon>
                                                                    <ListItemText>{t('actions.export.pdf')}</ListItemText>
                                                                </MenuItem>

                                                                <MenuItem 
                                                                    sx={{paddingRight:6.2}}
                                                                    onClick={(e) => handleButtonExport('ppt')}
                                                                >
                                                                    <ListItemIcon>
                                                                        <PowerPointIcon fontSize="small" />
                                                                    </ListItemIcon>
                                                                    <ListItemText>{t('actions.export.ppt')}</ListItemText>
                                                                </MenuItem>

                                                                <MenuItem 
                                                                    sx={{paddingRight:6.2}}
                                                                    onClick={(e) => handleButtonExport('excel')}
                                                                >
                                                                    <ListItemIcon>
                                                                        <ExcelIcon fontSize="small" />
                                                                    </ListItemIcon>
                                                                    <ListItemText>{t('actions.export.excel')}</ListItemText>
                                                                </MenuItem>
                                                                
                                                            </Menu>                                                                
                                                        </div>
                                                    */}
                                                            <PowerBIEmbed
                                                                //ref={reportRef}
                                                                embedConfig={{
                                                                    type: 'report',
                                                                    id: reportData?.reportId,
                                                                    embedUrl: reportData?.embedUrl + '&language=' + language, //&formatLocale=en-AU
                                                                    accessToken: reportData?.accessToken,
                                                                    tokenType: reportData?.delegated ? models.TokenType.Aad : models.TokenType.Embed,
                                                                    settings: {
                                                                        panes: {
                                                                            filters: {
                                                                                expanded: false,
                                                                                visible: false
                                                                            },
                                                                            pageNavigation: {
                                                                                visible: true
                                                                            }
                                                                        },
                                                                        bars: {
                                                                            actionBar: {
                                                                                visible: true,
                                                                                commands: true
                                                                            }
                                                                        },
                                                                        visualHeaders: {
                                                                            visible: true
                                                                        },
                                                                        background: models.BackgroundType.Transparent
                                                                    }
                                                                }}
                                                                cssClassName="powerbi-frame size-full" // w-full
                                                            /*getEmbeddedComponent={(embeddedComponent) => {
                                                                setReportObject(embeddedComponent);
                                                            }}*/
                                                            //onLoad={() => console.log('Reporte cargado')}
                                                            //onError={(error) => console.error('Error en Power BI:', error)}                                                        
                                                            /*
                                                            eventHandlers = {
                                                                new Map([
                                                                    //['loaded', function () {console.log('Report loaded');}],
                                                                    //['rendered', function () {console.log('Report rendered');}],
                                                                    //['error', function (event) {console.log(event.detail);}],
                                                                    //['visualClicked', () => console.log('visual clicked')],
                                                                    //['pageChanged', (event) => console.log(event)],                                                                
                                                                ])
                                                            }
                                                            */
                                                            />
                                                        </div>
                                                    :
                                                    <></>
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    </>
            }
        </div>
        </>
    );
}